import { render, staticRenderFns } from "./create_update.vue?vue&type=template&id=fba52f04&"
import script from "./create_update.vue?vue&type=script&lang=js&"
export * from "./create_update.vue?vue&type=script&lang=js&"
import style0 from "./create_update.vue?vue&type=style&index=0&id=fba52f04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports